import {
  LOAD_NOTIFICATIONS,
  SAVE_NOTIFICATIONS
} from '../constants/actionTypes/notifications';

export const initialState = {
  notificationsList: null
};

export default (state = initialState, action) => {
  const { type, notificationsList, notificationToShow } = action;

  switch (type) {
    case LOAD_NOTIFICATIONS:
      return {
        ...state,
        notificationsList
      };
    case SAVE_NOTIFICATIONS:
      return {
        ...state,
        notifications: notificationToShow
      };
    default:
      return state;
  }
};
